var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7083 5.70833H12.72M0.75 0.75V5.70833H4.25C6.18317 5.70833 7.68 7.45367 8.93417 8.92483C9.47393 9.55806 10.1644 10.0453 10.9419 10.3416C11.7194 10.6379 12.5589 10.7338 13.3832 10.6204C14.2075 10.5071 14.9901 10.1881 15.6587 9.69286C16.3273 9.19764 16.8606 8.54213 17.2094 7.78669C17.5581 7.03126 17.7112 6.20021 17.6544 5.37009C17.5977 4.53997 17.3329 3.73748 16.8846 3.03655C16.4362 2.33563 15.8187 1.7588 15.0889 1.35921C14.359 0.959617 13.5404 0.750114 12.7083 0.75H11.8333V1.33333C11.8333 1.64275 11.7104 1.9395 11.4916 2.15829C11.2728 2.37708 10.9761 2.5 10.6667 2.5H8.91667C8.60725 2.5 8.3105 2.37708 8.09171 2.15829C7.87292 1.9395 7.75 1.64275 7.75 1.33333V0.75H0.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackStaffIcon);
export default __webpack_public_path__ + "static/media/black_staff_icon.18dfa7343f630979bc14b578d7c56f4f.svg";
export { ForwardRef as ReactComponent };